import { JetView } from 'webix-jet';
import { devConfig, countries } from 'config/config';

/**
 * Class representing a table view for managing partner categories.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the table view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                { id: 'Id', header: '', hidden: true }, // Hidden ID column
                                {
                                    id: 'rating', // Rating column
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon template
                                    },
                                },
                                {
                                    id: 'Slug', // Slug column
                                    header: _('Slug'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Description column
                                    header: _('Descripción'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Order', // Order column
                                    header: _('Orden'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // State column
                                    header: _('Estado'), // Localized header
                                    width: 150,
                                    options: [
                                        { id: '0', value: _('Activa') }, // Active state option
                                        { id: '1', value: _('Inactiva') }, // Inactive state option
                                    ],
                                },
                                {
                                    id: 'Type', // Type column
                                    header: _('Tipo'), // Localized header
                                    width: 150,
                                    options: [
                                        { id: '0', value: _('Casino') }, // Casino type option
                                        { id: '1', value: _('Live Casino') }, // Live Casino type option
                                        { id: '2', value: _('Virtuales') }, // Virtual type option
                                        { id: '3', value: _('Mini Games') }, // Mini Games type option
                                        { id: '4', value: _('Payment') }, // Payment type option
                                    ],
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'PartnersCategories/GetPartnersCategories'; // API URL for fetching categories
        var filter = ''; // Filter string for API requests

        // Event listener for filtering partner categories
        this.on(this.app, 'partnerCategories:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            filter = string1; // Update filter variable
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=1000' + string1); // Load data with filters
        });

        // Popup for adding a new category
        var popupAdd = webix.ui({
            view: 'window',
            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
            width: 700,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Agregar Categoría'), // Localized label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center',
            modal: true, // Modal window
            body: {
                view: 'form',
                id: 'addform', // ID for the add form
                elements: [
                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Slug'), // Localized label
                                                name: 'Slug', // Field name
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'State', // Field name
                                                options: [
                                                    {
                                                        id: '0',
                                                        value: _('Activa'), // Active option
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Inactiva'), // Inactive option
                                                    },
                                                ],
                                                required: true, // Required field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Descripción'), // Localized label
                                                name: 'Description', // Field name
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order', // Field name
                                                type: 'number', // Number type
                                                required: true, // Required field
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                margin: 10,
                                rows: [
                                    {
                                        view: 'combo',
                                        labelPosition: 'top',
                                        label: _('Tipo'), // Localized label
                                        name: 'Type', // Field name
                                        options: [
                                            { id: '0', value: _('Casino') }, // Casino option
                                            {
                                                id: '1',
                                                value: _('Live Casino'), // Live Casino option
                                            },
                                            { id: '2', value: _('Virtuales') }, // Virtual option
                                            { id: '3', value: _('Mini Games') }, // Mini Games option
                                            { id: '4', value: _('Payment') }, // Payment option
                                        ],
                                        required: true, // Required field
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    const vthis = this; // Reference to the current button
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        const json = JSON.stringify(values, (key, val) => {
                                            if (typeof val === 'string') {
                                                return val
                                                    .replace(/ñ/g, '&#241;') // Encode special characters
                                                    .replace(/Ñ/g, '&#209;')
                                                    .replace(/á/g, '&#225;')
                                                    .replace(/Á/g, '&#193;')
                                                    .replace(/é/g, '&#233;')
                                                    .replace(/É/g, '&#201;')
                                                    .replace(/í/g, '&#237;')
                                                    .replace(/Í/g, '&#205;')
                                                    .replace(/ó/g, '&#243;')
                                                    .replace(/Ó/g, '&#211;')
                                                    .replace(/ú/g, '&#250;')
                                                    .replace(/Ú/g, '&#218;');
                                            }
                                            return val; // Return value
                                        });
                                        var objJsonB64 = btoa(
                                            unescape(encodeURIComponent(json)), // Base64 encode the JSON
                                        );
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersCategories/CreatePartnersCategories', // API URL for creating categories
                                                objJsonB64, // Base64 encoded JSON
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            webix.message(
                                                                'Categoría creada satisfactoriamente', // Success message
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=1000' + filter, // Reload grid data
                                                            );
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                            vthis.getTopParentView().hide(); // Close the popup
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Close the popup
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Localized error title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Localized error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Popup for editing an existing category
        var popupEdit = webix.ui({
            view: 'window',
            width: 700,
            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar') }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center',
            modal: true, // Modal window
            body: {
                view: 'form',
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Id'), // Localized label
                                                name: 'Id', // Field name
                                                hidden: true, // Hidden field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Slug'), // Localized label
                                                name: 'Slug', // Field name
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'State', // Field name
                                                options: [
                                                    {
                                                        id: '0',
                                                        value: _('Activa'), // Active option
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Inactiva'), // Inactive option
                                                    },
                                                ],
                                                readonly: false, // Editable field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        rows: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Descripción'), // Localized label
                                                name: 'Description', // Field name
                                                readonly: false, // Editable field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order', // Field name
                                                type: 'number', // Number type
                                                readonly: false, // Editable field
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                margin: 10,
                                rows: [
                                    {
                                        view: 'combo',
                                        labelPosition: 'top',
                                        label: _('Tipo'), // Localized label
                                        name: 'Type', // Field name
                                        options: [
                                            { id: '0', value: _('Casino') }, // Casino option
                                            {
                                                id: '1',
                                                value: _('Live Casino'), // Live Casino option
                                            },
                                            { id: '2', value: _('Virtuales') }, // Virtual option
                                            { id: '3', value: _('Mini Games') }, // Mini Games option
                                            { id: '4', value: _('Payment') }, // Payment option
                                        ],
                                        readonly: false, // Editable field
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    $$('editform').setValues(
                                        $$('editform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if ($$('editform').validate()) {
                                        // Validate form
                                        const json = JSON.stringify(values, (key, val) => {
                                            if (typeof val === 'string') {
                                                return val
                                                    .replace(/ñ/g, '&#241;') // Encode special characters
                                                    .replace(/Ñ/g, '&#209;')
                                                    .replace(/á/g, '&#225;')
                                                    .replace(/Á/g, '&#193;')
                                                    .replace(/é/g, '&#233;')
                                                    .replace(/É/g, '&#201;')
                                                    .replace(/í/g, '&#237;')
                                                    .replace(/Í/g, '&#205;')
                                                    .replace(/ó/g, '&#243;')
                                                    .replace(/Ó/g, '&#211;')
                                                    .replace(/ú/g, '&#250;')
                                                    .replace(/Ú/g, '&#218;');
                                            }
                                            return val; // Return value
                                        });
                                        var objJsonB64 = btoa(
                                            unescape(encodeURIComponent(json)), // Base64 encode the JSON
                                        );
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersCategories/UpdatePartnersCategories', // API URL for updating categories
                                                objJsonB64, // Base64 encoded JSON
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            webix.message(
                                                                'Categoría editada satisfactoriamente', // Success message
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=1000' + filter, // Reload grid data
                                                            );
                                                            this.getTopParentView().hide(); // Close the popup
                                                            $$('editform').setValues(
                                                                $$('editform').getCleanValues(), // Reset form values
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Close the popup
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Localized error title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Localized error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        $$('editform').bind($$('datatable')); // Bind edit form to data table
        this.on(this.app, 'openEdit', (item) => {
            $$('editform').setValues($$('editform').getCleanValues()); // Reset edit form values
            popupEdit.show(); // Show edit popup
        });
        this.on(this.app, 'add:button', (item) => {
            popupAdd.show(); // Show add popup
        });
    }
}

// FILE DOCUMENTED
